import React, { useState, useContext, useEffect } from "react";
import {
  Route,
  Switch,
  Redirect,
  withRouter,
  useLocation,
  useHistory,
} from "react-router-dom";
import { RootContext } from "../RootContextProvider";
import { Layout, notification, Icon } from "antd";
import CustomSider from "../components/sidebar/Sidebar";
import NavBar from "../components/navbar/NavBar";
import Links from "../components/Links/Links";
import Preview from "../components/Appearance/PagePreview";

import "../index.css";
import "./app.css";
import "../components/Links/Links";
import { fetchPages } from "../utils/utils";

import { getUser } from "../utils/me";
import { Row, Col } from "antd";
import { currentAccount } from "../utils/account";
import Appearance from "../components/Appearance/Appearance";
import PageSettings from "../components/PageSettings/PageSettings";
import Analytics from "../components/Analytics/Analytics";
import Admin from "../components/Admin/Admin";
import Billing from "../components/Billing/Billing";
import NewPage from "../components/NewPage/NewPage";

import { newVersion } from "../utils/utils";
import Welcome from "../components/Welcome/Welcome";

const { Content, Sider } = Layout;

const App = () => {
  const {
    setUser,
    setToken,
    setAccount,
    setPages,
    setLinks,
    setStateAccount,
    setListPages,
  } = useContext(RootContext);
  const location = useLocation();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [, setBlocked] = useState(false);
  const [viewAnalytics, setViewAnalytics] = useState(false);

  useEffect(() => {
    // const getPages = async () => {
    //   const pageIDToLoad = localStorage.getItem("pageToLoad");
    //   console.log(pageIDToLoad);
    //   await fetchPages(setListPages, setPages, setLinks, pageIDToLoad, history);
    // };

    const getUserLoad = async () => {
      await fetchUser();
      if (
        window.location.pathname.includes("/analytics") ||
        window.location.pathname.includes("/admin") ||
        window.location.pathname.includes("/billing") ||
        window.location.pathname.includes("/new-page") ||
        window.location.pathname.includes("/welcome")
      ) {
        setViewAnalytics(true);
      } else {
        setViewAnalytics(false);
      }
      setLoading(false);
    };
    // if (user && account) {
    //   console.log("test");
    //   setLoading(true);
    //   getPages();
    //   setLoading(false);
    // }
    // if (!user || !account) {
    getUserLoad();
    // }

    history.listen(() => {
      newVersion(fetch).then((changed) => {
        if (changed) {
          window.location.reload();
        }
      });
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    history.listen(() => {
      if (
        window.location.pathname.includes("/analytics") ||
        window.location.pathname.includes("/admin") ||
        window.location.pathname.includes("/billing") ||
        window.location.pathname.includes("/new-page") ||
        window.location.pathname.includes("/welcome")
      ) {
        setViewAnalytics(true);
      } else {
        setViewAnalytics(false);
      }
    });
  }, [history]);

  const openNotification = () => {
    notification.config({
      duration: 30,
    });
    notification.open({
      message: "Votre compte n'est pas activé",
      description:
        "Linksight n'est pas encore ouvert au public. Contactez notre équipe dans le chat pour activer votre compte.",
      icon: <Icon type="message" style={{ color: "#108ee9" }} />,
    });
  };

  const fetchUser = async () => {
    try {
      console.log("entering fetch user");
      const user = await getUser();
      const account = await currentAccount();
      if (user.IsActivated === 0) {
        setBlocked(true);
        await resetCurrentUser();
        await openNotification();
        setLoading(false);
        return localStorage.clear();
      }
      if (user.EmailValidated === 0) {
        setToken(null, true);
        setBlocked(true);
        if (location.pathname !== "/validation") {
          history.push("/validation");
        }
        setLoading(false);
        return;
      } else {
        setUser(user);
        setAccount(account);
        const pageIDToLoad = localStorage.getItem("pageToLoad");
        await fetchPages(
          setListPages,
          setPages,
          setLinks,
          pageIDToLoad,
          history,
          false,
          account
        );
      }
    } catch (err) {
      console.log(err);
      setToken(null, true);
      setUser(null);
      setStateAccount(null);
      history.push("/signin");
    } finally {
      setLoading(false);
    }
  };

  const resetCurrentUser = () => {
    localStorage.clear();

    setToken(null, true);
    setUser(null);
    setStateAccount(null);
    history.push("/signin");
  };

  if (loading) {
    return <div className="loader">{/* <Loader /> */}</div>;
  }

  return (
    <Layout className="App main">
      <Route exact path="/">
        <Redirect to="/links" />
      </Route>
      {/* <Redirect exact path="/" to="/links/" /> */}
      <Sider collapsed={true}>
        <CustomSider logout={resetCurrentUser} />
      </Sider>
      <Layout>
        <NavBar logout={resetCurrentUser} />
        <div className="global-container">
          {!viewAnalytics ? (
            <Row>
              <Col xl={16} lg={16} md={12} xs={24}>
                <Content className="content-container-preview">
                  <Switch>
                    <Route exact path="/links" component={Links} />
                    <Route exact path="/appearance/" component={Appearance} />
                    <Route exact path="/settings/" component={PageSettings} />
                  </Switch>
                </Content>
              </Col>
              <Col xl={8} lg={8} md={12} xs={24} className="preview-iphone">
                <Preview />
              </Col>
            </Row>
          ) : (
            <Content className="content-container">
              <Switch>
                <Route exact path="/analytics" component={Analytics} />
                <Route exact path="/admin" component={Admin} />
                <Route exact path="/billing" component={Billing} />
                <Route exact path="/new-page" component={NewPage} />
                <Route exact path="/welcome" component={Welcome} />
              </Switch>
            </Content>
          )}
        </div>
      </Layout>
    </Layout>
  );
};

export default withRouter(App);
